import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import TeaserScrollOverviewImage from "@default/paragraphs/scroll-overview/components/teaser-scroll-overview-image";
import CustomHyphenation from "@default/general-components/custom-hyphenation";
import { encodeUrl } from "@default/lib/encode-url";

const ActItem = React.memo(({ item, index, isActive }) => {
  return (
    <li
      className="scroll-overview-listener acts-scroll-item"
      id={encodeUrl(`${item.title}-${item.id}`)}
      data-teaser-index={index}
      aria-current={isActive}
    >
      <Link to={item.url.path} className="flex-wrap infos">
        {/* Mobile-only image, hidden on desktop via CSS */}
        {item.fieldImage && (
          <div className="acts-item__mobile-image">
            <TeaserScrollOverviewImage item={item} index={index} />
          </div>
        )}
        <h3 className="name">
          <CustomHyphenation length={8}>{item.title}</CustomHyphenation>
        </h3>
      </Link>
    </li>
  );
});

ActItem.displayName = "ActItem";

ActItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.shape({ path: PropTypes.string }),
    fieldImage: PropTypes.object,
  }).isRequired,
  index: PropTypes.number.isRequired,
  isActive: PropTypes.bool,
};

export default ActItem;
